import React from 'react';
import { useLocale } from 'use-intl';
import Image from '../../../image';
import styles from './PartnersSection.module.css';
import type {
  ConferencePartnerGroupItem,
  ConferencePartnerListResp,
  ConferenceSite,
} from '../types';

interface PartnersSectionProps {
  data?: ConferencePartnerListResp;
  title?: string;
  site?: ConferenceSite;
}

const getPartnerGroupTitle = (group: ConferencePartnerGroupItem, isZh: boolean) =>
  (isZh ? group.title || group.title_en : group.title_en || group.title) || '-';

/**
 * 合作伙伴组件
 */
export default function PartnersSection({
  data,
  title: _title,
  site = 'zh',
}: PartnersSectionProps) {
  const locale = useLocale();
  const isZh = locale === 'zh';
  const isOverseaSite = site === 'en';
  const groups = (data?.cooperateCategoryList || []).filter(
    (item) => (item.cooperateList || []).length > 0
  );

  if (!groups.length) {
    return null;
  }

  return (
    <section id="partners" className={styles.section}>
      <div className={styles.container}>
        <div className={styles.groupList}>
          {groups.map((group) => (
            <div className={styles.groupBlock} key={group.id || group.title}>
              <h3
                className={
                  isOverseaSite
                    ? `${styles.groupTitle} ${styles.groupTitleOversea}`
                    : styles.groupTitle
                }
              >
                {getPartnerGroupTitle(group, isZh)}
              </h3>
              <div className={styles.logoList}>
                {(group.cooperateList || []).map((partner) => (
                  <div
                    className={styles.logoCard}
                    key={partner.id || partner.imgUrl || partner.name}
                  >
                    <Image
                      src={partner.imgUrl || partner.imgUrl_m || ''}
                      alt={
                        (isZh
                          ? partner.name || partner.name_en
                          : partner.name_en || partner.name) || 'partner'
                      }
                      className={styles.logoImage}
                      loading="lazy"
                    />
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
